import Swiper from "swiper";
import { Navigation, EffectFade} from 'swiper/modules';

/// ##### Swiper

const reviewSections = document.querySelectorAll('.section-reviews__reviews-wrapper');


Swiper.use([Navigation, EffectFade]);
let reviewsArray = [];

const initSwiper = () => {
    reviewSections.forEach((section, i) => {
        let init = false;
        const prevEl = section.parentElement.parentElement.querySelector(`.section-reviews__arrow--next`);
        const nextEl = section.parentElement.parentElement.querySelector(`.section-reviews__arrow--prev`);
        section.classList.add(`section-reviews__reviews-wrapper-${i}`);
        
        if (prevEl) prevEl.classList.add(`section-reviews__arrow--next-${i}`);
        if (nextEl) nextEl.classList.add(`section-reviews__arrow--prev-${i}`);
        
        if (section.querySelector('.swiper-wrapper')) {
            const reviewCarousel = new Swiper(`.section-reviews__reviews-wrapper-${i}`, {
                slidesPerView: 'auto',
                slideActiveClass: 'is-active',
                loop: 1,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 500,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
                    nextEl: `.section-reviews__arrow--next-${i}`,
                    prevEl: `.section-reviews__arrow--prev-${i}`,
                },
            });
            reviewsArray.push(reviewCarousel);
        }
    })
}

initSwiper();